import script from "./userLevelTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./userLevelTwo.vue?vue&type=script&setup=true&lang=js"

import "./userLevelTwo.vue?vue&type=style&index=0&id=cd71e8c6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd71e8c6"]])

export default __exports__